module.exports = __webpack_public_path__ + "img/bg-history.a84cf779.png";